import type { AxiosError } from 'axios'
import { GET_API_URL } from 'shared/config'
import {
  CONFIG_API_URLS,
  is_api_error_last_cache,
  KEY_HOST_CACHE_NEXT_API,
  parseUrlsApi,
  remove_all_host_cache,
  set_host_cache,
  set_host_error_last_cache,
} from 'shared/config/lib/getConfigUrls'
import { baseApi } from 'entities/Auth'
import { sentEventSentry } from 'entities/Sentry'
import { EventEmitterStore } from 'entities/EventEmitter/store/EventEmitterStore'

export const emitterChangeAPI = new EventEmitterStore()

function change_api_domain() {
  const init = () => {
    const exist = window.localStorage.getItem(KEY_HOST_CACHE_NEXT_API)

    if (!exist) {
      const freeDomains = Object.keys(parseUrlsApi(CONFIG_API_URLS)).map((item) => {
        return {
          [item]: true,
        }
      })

      window.localStorage.setItem(KEY_HOST_CACHE_NEXT_API, JSON.stringify(freeDomains))
    }
  }

  if (is_api_error_last_cache()) {
    remove_all_host_cache()
    init()
  }

  return {
    init: init,
    getNext() {
      const JSONData = window.localStorage.getItem(KEY_HOST_CACHE_NEXT_API)

      if (JSONData) {
        try {
          const data = JSON.parse(JSONData) as { [key: string]: boolean }[]

          if (Array.isArray(data)) {
            const domain_api = data.reduce<string>((state, item) => {
              const [key, value] = Object.entries(item)[0]

              if (!state && value) {
                state = key
              }

              return state
            }, '')

            if (domain_api) return domain_api

            return ''
          }
        } catch (e) {
          return ''
        }
      }

      return ''
    },

    update(key: string, value: boolean) {
      const JSONData = window.localStorage.getItem(KEY_HOST_CACHE_NEXT_API)

      if (JSONData) {
        try {
          let data = JSON.parse(JSONData) as { [key: string]: boolean }[]

          if (Array.isArray(data)) {
            data = data.map((item) => {
              const [key_local] = Object.entries(item)[0]

              if (key_local === key) {
                item[key] = value
              }

              return item
            })

            window.localStorage.setItem(KEY_HOST_CACHE_NEXT_API, JSON.stringify(data))
          }
        } catch (e) {
          console.error(e)
        }
      }
    },

    initNextDomain(error: AxiosError) {
      this.init()

      const freeDomainKey = this.getNext()

      if (freeDomainKey) {
        this.update(freeDomainKey, false)
        set_host_cache(freeDomainKey)
        emitterChangeAPI.emit('change_api', freeDomainKey)
        sentEventSentry({
          event: '[API] change_api',
          name: 'api:change_domain',
          level: 'log',
          error: error,
        })

        if (!error.config) return Promise.reject(error)

        error.config.baseURL = GET_API_URL()

        return baseApi.request(error.config)
      }

      set_host_error_last_cache('1')

      return Promise.reject(error)
    },
  }
}

export const change_auth_domain_api = change_api_domain()

change_auth_domain_api.init()
